module.exports = __webpack_public_path__ + "static/media/personal-card.f9044c1c.svg";